<template>
    <div class="customer-analytics">
      <div class="container">
        <div class="card">
          <div class="card-header">
            <h3>Enhanced Customer Analytics</h3>
          </div>
          <div class="card-body">
            <!-- Date Range Filter -->
            <div class="row mb-3">
              <div class="col-md-6">
                <label for="startDate">Start Date:</label>
                <input
                  type="date"
                  id="startDate"
                  v-model="startDate"
                  class="form-control"
                />
              </div>
              <div class="col-md-6">
                <label for="endDate">End Date:</label>
                <input
                  type="date"
                  id="endDate"
                  v-model="endDate"
                  class="form-control"
                />
              </div>
            </div>
  
            <!-- Metrics Display (Cards) -->
            <div class="row">
              <div
                class="col-md-4 mb-3"
                v-for="(metric, index) in metrics"
                :key="index"
              >
                <div class="card h-100">
                  <div class="card-body">
                    <h5 class="card-title">{{ metric.title }}</h5>
                    <p class="card-text">{{ metric.value }}</p>
                  </div>
                </div>
              </div>
            </div>
  
            <!-- Additional note: this is a static UI-only example -->
            <div class="alert alert-info mt-3">
              Data is static. In a production system, these metrics would be dynamically fetched.
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "CustomerAnalyticsUI",
    data() {
      return {
        // Static date values for demonstration
        startDate: "2024-01-01",
        endDate: "2024-01-31",
        // Fake metrics for UI demonstration purposes
        metrics: [
          { title: "Avg. Days to Convert (Leads)", value: "12 days" },
          { title: "Sales Invoices (Value / Qty)", value: "$15,000 / 320 items" },
          { title: "Total Quotations Sent", value: 45 },
          { title: "Total Revenue Obtained", value: "$42,500" },
          { title: "Different Products Sold", value: 18 },
          { title: "Support Tickets Raised", value: 7 },
        ],
      };
    },
  };
  </script>
  
  <style scoped>
  .customer-analytics {
    padding: 20px;
  }
  .card {
    margin-bottom: 20px;
  }
  </style>
  